import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';

export const namespace = 'goodCategoryList';

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_MORE_SUCCESS = `${namespace}/fetch-more-success`;
const REMOVE_BY_ID_SUCCESS = `${namespace}/remove-by-id-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			request({}, FETCH_DATA_SUCCESS)(dispatch);
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),
		removeById: (id) => (dispatch, getState) => {
			const request = http({
				url: `${endpoints.GOOD_CATEGORIES.BASE}/${id}`,
				method: 'delete',
				actions: [REMOVE_BY_ID_SUCCESS, FETCH_DATA_ERROR]
			});

			return request(dispatch).then((action) => {
				if (action.type === REMOVE_BY_ID_SUCCESS) {
					dispatch(actions.own.fetchData());
				}
			});
		}
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data.rows,
			isLoading: false,
			isError: false
		}),
		[FETCH_MORE_SUCCESS]: (state, action) => ({
			...state,
			data: state.data.concat(action.payload.data.rows),
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	}
);

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field]
};

function request(query, successActionType) {
	return http({
		url: endpoints.GOOD_CATEGORIES.BASE,
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/goods/category/list/index.js